<template>
	<div>
		<div class="join_banner">
			<div class="kuang">
				<div class="game_banner_txt">
					<h1>{{ $t('message.index36t') }}</h1>
					<p class="index_p">
						{{ $t('message.index37t') }}
					</p>
				</div>
			</div>
			<div class="bot_rol" @click="scrollToSection('section2')"><img src="@/images/banner_logo_10.png"/></div>
		</div>
		
		<div class="join2 index3" id="section2">
			<div class="kuang">
				<div class="join_top">
					<div class="join_tit">{{ $t('message.index38t') }}</div>
					<div class="en_dsc">RECRUITMENT</div>
				</div>
				<!-- 选项卡菜单 -->
				<ul class="tab-menu">
				  <li v-for="(item, index) in tabs" :key="index" :class="{ active: activeTab === index }" @click="toggleTab(index)">
					<div class="tab_title">
						<span>{{ item.title }}</span>

						<i class="arrow" :class="activeTab === index ? 'up' : 'down'" @click.stop="toggleTab(index)"></i>
					</div>
					<!-- 使用 transition 包裹要过渡的内容 -->
					<transition name="slide">
					  <div v-if="activeTab === index" class="content" @click.stop>
						<div  v-for="(item , index) in item.details" class="content_section">
							<div class="details-title">{{ item.name }}：</div>
							<ul>
								<li v-for="citem in item.content">{{ citem }}</li>
							</ul>
						</div>
						<center>
						<button @click="open_join_overlay(activeTab)" class="join_but">{{ $t('message.join') }}</button>
						</center>
					  </div>
					</transition>
				  </li>
				</ul>
			</div>
		</div>
		
		<div class="join3">
			<div class="join_top">
				<div class="join_tit">{{ $t('message.index39t') }}</div>
				<div class="en_dsc">OFFICE ENVIRONMENT</div>
			</div>
			
			<!-- Swiper -->
			<div class="swiper mySwiper">
			   <div class="swiper_control">
				   <div class="swiper-prev"><</div>
				   <div class="swiper-next">></div>
			  </div>
			  <div class="swiper-wrapper">
				<div class="swiper-slide" v-for="item in swiper">
					<a :href="item.url"><img :src="item.images"/></a>
				</div>
			  </div>
			</div>
		</div>
	
		<div id="join_form_overlay" v-cloak v-show="join_overlay">
		    <div class="join_box">
		        <div class="join_box_close" @click="close_join_overlay"><img src="@/images/close_03.png"/></div>
		        <div class="clear"></div>
		        <div class="join_box_content">
		           <div class="product_detail">
		               <div class="product_detail_text">
		                   <div class="Jform_title">{{ $t('message.index63t') }}</div>
		                   <div class="Jform_dsc"><img src="@/images/logo.png"/>{{ $t('message.index64t') }}</div>
		               </div>
					   <img src="@/images/join_form_03.jpg"/>
		           </div>
		           
		           <form class="join_form" @submit.prevent="submitForm">
					   <div class="half_input">
						   <div class="form-group">
							   <input type="text" id="name" v-model="userName" :placeholder="$t('message.index40t')" @focus="clearError('userName')" />
							   <div v-if="errors.userName" class="error-message">{{ errors.userName }}</div>
						   </div>
						   <div class="form-group">
								<input type="text" id="age" v-model="age" :placeholder="$t('message.index41t')" @focus="clearError('age')"/>
								<div v-if="errors.age" class="error-message">{{ errors.age }}</div>
						   </div>
						   <div class="form-group">
							   <el-select id="sex" v-model="sex" :placeholder="$t('message.index52t')" @focus="clearError('sex')">
									<el-option :label="$t('message.index44t')" value="male"></el-option>
									<el-option :label="$t('message.index43t')" value="female"></el-option>
							   </el-select>
							   <div v-if="errors.sex" class="error-message">{{ errors.sex }}</div>
						   </div>
							
						   <div class="form-group">
							   <el-select id="nationality" v-model="nationality" filterable :placeholder="$t('message.index45t')" @focus="clearError('nationality')" >
									 <el-option
									   v-for="option in filteredOptions"
									   :key="option.value"
									   :label="option.label"
									   :value="option.value"
									 />
							   </el-select>
							   <div v-if="errors.nationality" class="error-message">{{ errors.nationality }}</div>
						   </div>
						   <div class="form-group">
							   <input type="text" id="university" v-model="university" :placeholder="$t('message.index46t')" @focus="clearError('university')"/>
							   <div v-if="errors.university" class="error-message">{{ errors.university }}</div>
						   </div>
						   <div class="form-group">
							   <input type="text" id="specialty" v-model="specialty" :placeholder="$t('message.index47t')" @focus="clearError('specialty')"/>
							   <div v-if="errors.specialty" class="error-message">{{ errors.specialty }}</div>
						   </div>
						   
						   <div class="form-group">
							   <input type="text" id="mobile" v-model="mobile" :placeholder="$t('message.index47t')" @focus="clearError('mobile')"/>
							   <div v-if="errors.mobile" class="error-message">{{ errors.mobile }}</div>
						   </div>
						   
						   <div class="form-group">
							   <input type="text" id="email" v-model="email" :placeholder="$t('message.index47t')" @focus="clearError('email')"/>
							   <div v-if="errors.email" class="error-message">{{ errors.email }}</div>
						   </div>
						   
					   </div>
					   
					   <div class="full_input">
						   <div class="form-group">
							   <input type="text" id="address" v-model="address" :placeholder="$t('message.index50t')" @focus="clearError('address')"/>
							   <div v-if="errors.address" class="error-message">{{ errors.address }}</div>
						   </div>
						   
						   <textarea id="job_description" v-model="jobDescription" :placeholder="$t('message.index51t')"></textarea>
					   </div>
					   
					   
		               <div class="jform_file">
		                 <label for="file">{{ $t('message.index53t') }}</label>
						 <div class="file-input-wrapper">
						   <input type="file" id="file" ref="fileInput" class="file-input" @change="handleFileChange" />
						   <label for="file" class="custom-file-label">{{ $t('message.index54t') }}</label>
						 </div>
						 <p>{{ $t('message.index56t') }}</p>
		               </div>
	
		                <input type="number" id="post_id" hidden v-model="postId" />

		               <center><button class="click_join">{{ $t('message.index57t') }}</button></center>
		               
		           </form>
				   
	
		        </div>
		    </div>
		  </div>
	</div>
</template>

<script>
	import axios from 'axios';
	import Swiper from 'swiper';
	
	import 'element-ui/lib/theme-chalk/index.css';
	
	import '@/styles/swiper-bundle.css'; 
	
	export default {
	    name: 'Join',
	    data() {
	        return {
		      errors: {},
	          tabs: [
	            { 
					title: '云服务技术支持JD(两名)', 
					job: '面议 | 技术开发类 | 本科及以上', 
					time: '2023.07.06', 
					content: '职位描述• 根据客户需求，提供AWS、AZURE云平台的技术咨询和在线技术支持• 深入了解客户业务架构，为客户赋能，驱动运维能力升级、容灾能力升级等。• 协助客户与AWS等原厂之间的工单交互和工单处理• 协助组长处理本公司的基础前后台网络环境搭建和维护',
					details:[{
					 	name:　'职位描述',
					 	content: [
					 		'根据客户需求，提供AWS、AZURE云平台的技术咨询和在线技术支持',
					 		'深入了解客户业务架构，为客户赋能，驱动运维能力升级、容灾能力升级等。',
					 		'协助客户 与 AWS等原厂之间的工单交互和工单处理',
					 		'协助组长处理本公司的基础前后台网络环境搭建和维护'
					 	]
					},{
					 	name:　'任职资格',
					 	content: [
					 		'新加坡本地公民；',
					 		'流利的汉语口语和英语读写能力。',
					 		'本科及以上学历，计算机相关专业，1年以上服务器运维或IT技术支持工作经验。',
					 		'有一定网络基础，对TCP/IP、HTTP/HTTPS等原理有深刻的理解。',
					 		'了解常用的Linux服务器命令，了解Mysql，Redis，Mongdb等常用数据库。',
					 		'熟悉常见的运维工具和技术，如Nginx，Docker，Jenkins，Tomcat等。',
					 		'熟悉常用的脚本语言 如Shell，Python，Go 使用者优先。',
					 		'具有 Java，C++，C#，javascript 等语言基础的优先',
					 		'具有游戏运维经验 和 有各种第三方API对接经验 者优先',
					 		'具有良好独立分析、解决问题的能力，可以快速应对线上各种紧急情况。',
					 		'有较强的责任感，有较强的学习和接受知识的能力，具备优秀的文档能力，使用文字、图示清楚地表达架构意图，能够熟练编写各类技术文档。',
					 		'熟悉使用常见的云环境如AWS，AZURE等，有相关云计算厂商使用工作经验者，持有相关证书者优先。'
					 	]
					}],
				},
	            { 
					title: '云服务技术支持Leader JD(两名)', 
					job: '面议 | 技术开发类 | 本科及以上', 
					time: '2023.07.06', 
					details:[{
					 	name:　'职位描述',
					 	content: [
					 		'根据客户需求，提供AWS、AZURE云平台的技术咨询和在线技术支持',
					 		'深入了解客户业务架构，为客户赋能，驱动运维能力升级、容灾能力升级等。',
					 		'协助客户 与 AWS等原厂之间的工单交互和工单处理',
					 		'协助组长处理本公司的基础前后台网络环境搭建和维护'
					 	]
					},{
					 	name:　'任职资格',
					 	content: [
					 		'新加坡本地公民；',
					 		'流利的汉语口语和英语读写能力。',
					 		'本科及以上学历，计算机相关专业，1年以上服务器运维或IT技术支持工作经验。',
					 		'有一定网络基础，对TCP/IP、HTTP/HTTPS等原理有深刻的理解。',
					 		'了解常用的Linux服务器命令，了解Mysql，Redis，Mongdb等常用数据库。',
					 		'熟悉常见的运维工具和技术，如Nginx，Docker，Jenkins，Tomcat等。',
					 		'熟悉常用的脚本语言 如Shell，Python，Go 使用者优先。',
					 		'具有 Java，C++，C#，javascript 等语言基础的优先',
					 		'具有游戏运维经验 和 有各种第三方API对接经验 者优先',
					 		'具有良好独立分析、解决问题的能力，可以快速应对线上各种紧急情况。',
					 		'有较强的责任感，有较强的学习和接受知识的能力，具备优秀的文档能力，使用文字、图示清楚地表达架构意图，能够熟练编写各类技术文档。',
					 		'熟悉使用常见的云环境如AWS，AZURE等，有相关云计算厂商使用工作经验者，持有相关证书者优先。'
					 	]
					}],
				},
	            { 
					title: '云服务技术支持Leader JD(两名)', 
					job: '面议 | 技术开发类 | 本科及以上', 
					time: '2023.07.06', 
					details:[{
					 	name:　'职位描述',
					 	content: [
					 		'根据客户需求，提供AWS、AZURE云平台的技术咨询和在线技术支持',
					 		'深入了解客户业务架构，为客户赋能，驱动运维能力升级、容灾能力升级等。',
					 		'协助客户 与 AWS等原厂之间的工单交互和工单处理',
					 		'协助组长处理本公司的基础前后台网络环境搭建和维护'
					 	]
					},{
					 	name:　'任职资格',
					 	content: [
					 		'新加坡本地公民；',
					 		'流利的汉语口语和英语读写能力。',
					 		'本科及以上学历，计算机相关专业，1年以上服务器运维或IT技术支持工作经验。',
					 		'有一定网络基础，对TCP/IP、HTTP/HTTPS等原理有深刻的理解。',
					 		'了解常用的Linux服务器命令，了解Mysql，Redis，Mongdb等常用数据库。',
					 		'熟悉常见的运维工具和技术，如Nginx，Docker，Jenkins，Tomcat等。',
					 		'熟悉常用的脚本语言 如Shell，Python，Go 使用者优先。',
					 		'具有 Java，C++，C#，javascript 等语言基础的优先',
					 		'具有游戏运维经验 和 有各种第三方API对接经验 者优先',
					 		'具有良好独立分析、解决问题的能力，可以快速应对线上各种紧急情况。',
					 		'有较强的责任感，有较强的学习和接受知识的能力，具备优秀的文档能力，使用文字、图示清楚地表达架构意图，能够熟练编写各类技术文档。',
					 		'熟悉使用常见的云环境如AWS，AZURE等，有相关云计算厂商使用工作经验者，持有相关证书者优先。'
					 	]
					}],
				},
	          ],
			  swiper:[
				  {url:'#',images:require('@/images/join_03.jpg')},
				  {url:'#',images:require('@/images/join_05.jpg')},
				  {url:'#',images:require('@/images/join_07.jpg')},
				  {url:'#',images:require('@/images/join_03.jpg')},
				  {url:'#',images:require('@/images/join_05.jpg')},
				  {url:'#',images:require('@/images/join_07.jpg')},
			  ],
	          activeTab: -1, // 默认选中的选项卡，-1 表示没有选中
			  join_overlay: false,
			  file: null,
			  jobDescription: '',
			  postId: null,
			  userName: '',
			  sex: null,
			  age: '',
			  nationality: '',
			  address: '',
			  university: '',
			  specialty: '',
			  mobile: '',
			  email: '',
			  selectedNationality: null,
			  searchKeyword: "",
			  nationalityOptions: [
				  { label: this.$t('message.index70t'), value: "China" },
				  { label: this.$t('message.index71t'), value: "Singapore" },
				  { label: this.$t('message.index72t'), value: "New Zealand" },
				  { label: this.$t('message.index73t'), value: "United States" },
				  { label: this.$t('message.index74t'), value: "Japan" },
			  ],
	        };
	      },
		  watch: {
		      //'$i18n.locale': 'updateNationalityOptions',
			  '$i18n.locale': function (newLocale, oldLocale) {
			        // 更新错误信息
			        this.errors = {};
					this.updateNationalityOptions();
			      }
		  },
		  computed: {
		      filteredOptions() {
		        return this.nationalityOptions.filter((option) =>
		          option.label.toLowerCase().includes(this.searchKeyword.toLowerCase())
		        );
		      },
		    },
		  mounted() {
			new Swiper('.mySwiper', {
			  slidesPerView: 3,
			  spaceBetween: 20,
			  freeMode: true,
			  loop: true,
			  navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev',
			  },
			  breakpoints: {
				400: {
				  slidesPerView: 2,
				  spaceBetween: 10,
				},
				768: {
				  slidesPerView: 3,
				  spaceBetween: 20,
				},
				1024: {
				  slidesPerView: 3,
				  spaceBetween: 20,
				},
			  },
			});
		  },
	      methods: {
		    updateNationalityOptions() {
				this.nationalityOptions = [
				  { label: this.$t('message.index70t'), value: "China" },
				  { label: this.$t('message.index71t'), value: "Singapore" },
				  { label: this.$t('message.index72t'), value: "New Zealand" },
				  { label: this.$t('message.index73t'), value: "United States" },
				  { label: this.$t('message.index74t'), value: "Japan" },
				];
			},
			clearError(field) {
			  // 当 <input> 获得焦点时，清空相应的错误信息
			  if (this[field] != '') {
				  this.errors[field] = '';
			  }
			},
			scrollToSection(link) {
			  this.$scrollToSection(link);
			},
	        toggleTab(index) {
	          this.activeTab = this.activeTab === index ? -1 : index;
	        },
			open_join_overlay(e){
				this.postId = e;
				this.errors = {};
				this.join_overlay = true;
			},
			close_join_overlay(){
				this.join_overlay = false;
			},
			handleFileChange(event) {
				this.file = event.target.files[0];
				if (file) {
				  const allowedFormats = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'zip'];
				  const maxSizeInBytes = 100 * 1024 * 1024; // 100 MB in bytes
		  
				  const fileExtension = file.name.split('.').pop().toLowerCase();
				  const fileSize = file.size;
		  
				  if (!allowedFormats.includes(fileExtension)) {
					alert(this.$t('message.index68t'));
					this.resetFileInput();
					return;
				  }
		  
				  if (fileSize > maxSizeInBytes) {
					alert(this.$t('message.index69t'));
					this.resetFileInput();
					return;
				  }
		
				}
			},
			resetFileInput() {
			      this.$refs.fileInput.value = '';
			},
			validateInput() {
			  // 如果有错误，设置错误信息到errors对象
			  this.errors = {};
			  if (!this.userName) {
				this.errors.userName = this.$t('message.index75t');
			  }
			  if (!this.sex) {
				this.errors.sex = this.$t('message.index75t');
			  }
			  if (!this.age) {
				this.errors.age = this.$t('message.index75t');
			  }
			  if (!this.nationality) {
			  	this.errors.nationality = this.$t('message.index75t');
			  }
			  if (!this.university) {
			  	this.errors.university = this.$t('message.index75t');
			  }
			  if (!this.specialty) {
			  	this.errors.specialty = this.$t('message.index75t');
			  }
			  if (!this.mobile) {
				this.errors.mobile = this.$t('message.index75t');
			  }
			  if (!this.email) {
				this.errors.email = this.$t('message.index75t');
			  }
			  if (!this.address) {
				this.errors.address = this.$t('message.index75t');
			  }
			  
			  // 检查是否有错误
			  return Object.keys(this.errors).length === 0;
			},
			submitForm() {

				const isValid = this.validateInput();
				
				if (isValid) {
					// 构建表单数据
					const formData = new FormData();
					formData.append('file', this.file);
					formData.append('job_description', this.jobDescription);
					formData.append('post_id', this.postId); //post_id 代表申请的什么职位
					formData.append('name', this.userName);
					formData.append('sex', this.sex);
					formData.append('age', this.age);
					formData.append('nationality', this.nationality);
					formData.append('address', this.address);
					formData.append('university', this.university);
					formData.append('specialty', this.specialty);
					formData.append('mobile', this.mobile);
					formData.append('email', this.email);
					
					// 发送 POST 请求
					axios.post('http://admintest.kaitech.com/v1/kai/postResume/uploadResume', formData)
					  .then(response => {
						// 处理成功响应
					  })
					  .catch(error => {
						// 处理错误
					  });
				}
			}
	      },
		  created() {
			this.updateNationalityOptions();
		  },
	};
</script>

